import { atomFamily } from "jotai/utils";
import { createPersistedAtom } from "./utils/createPersistedAtom";
import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { VehicleType } from "types/DigitalJourneySession";

export const sessionVehicleTypeAtom = atomFamily((sessionId: string) => createPersistedAtom(`vehicleType-${sessionId}`, null as VehicleType | null));
export const vehicleTypeAtom = createDerivedSessionAtom<VehicleType | null>(sessionVehicleTypeAtom);